"use client";
import {
  useSelectContext
} from "../__chunks/KZ2S4ZC5.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import {
  useStoreState
} from "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-value.tsx
function SelectValue({
  store,
  fallback,
  children
} = {}) {
  const context = useSelectContext();
  store = store || context;
  const value = useStoreState(store, (state) => (state == null ? void 0 : state.value) || fallback);
  if (children) {
    return children(value || "");
  }
  return value;
}
export {
  SelectValue
};
